import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Language } from "models";

const formatLanguageOptions = (languages: Language[]) => languages.map(({ language_code }) => ({ key: language_code, value: language_code, text: language_code }));

export const useLanguagesQuery = () =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.languages,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data?.languages ?? [],
    select: formatLanguageOptions
  });
